import { render, staticRenderFns } from "./monitorPreview.vue?vue&type=template&id=6d6f7920&scoped=true&"
import script from "./monitorPreview.vue?vue&type=script&lang=js&"
export * from "./monitorPreview.vue?vue&type=script&lang=js&"
import style0 from "./monitorPreview.vue?vue&type=style&index=0&id=6d6f7920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f7920",
  null
  
)

export default component.exports